import { ApiConfiguration } from '../models/api-configuration.model';
import { apiSlice } from '../../../setup/api/api.slice';
import { ApiDataResponse } from '../../shared/models/api-response.model';

export const apiConfigurationEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        apiConfiguration: builder.query<ApiConfiguration, void>({
            query: () => '/configuration',
            keepUnusedDataFor: 60,
            transformResponse(baseQueryReturnValue) {
                return (baseQueryReturnValue as ApiDataResponse<ApiConfiguration>).data;
            },
        }),
    }),
});

export const { useApiConfigurationQuery } = apiConfigurationEndpoints;
